// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"084c2e05","761":"17730eb5","834":"b1943aa1"}[chunkId] + ".chunk.js";
};